import {
  GET_USER_LIST_DATA, INVITE_USER, SAVE_USER_LIST_DATA, GET_USER_EMAIL_CONTACT_DATA,
  DELETE_USER, RESET_USER_EMAIL_CONTACT_DATA, DEACTIVATE_USER, RESET_USER_PASSWORD,
} from '../../../constants/system/actions';

const getUserListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_USER_LIST_DATA, payload, resolve, reject,
});

const saveUserListData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_USER_LIST_DATA, payload, resolve, reject,
});

const inviteUser: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: INVITE_USER, payload, resolve, reject,
});

const deactivateUser: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: DEACTIVATE_USER, payload, resolve, reject,
});

const resetUserPassword: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: RESET_USER_PASSWORD, payload, resolve, reject,
});

const getUserEmailContactData: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: GET_USER_EMAIL_CONTACT_DATA, payload, resolve, reject,
});

const deleteUser: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: DELETE_USER, payload, resolve, reject,
});

const resetUserEmailContactData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_USER_EMAIL_CONTACT_DATA, payload,
});

export {
  getUserListData,
  saveUserListData,
  inviteUser,
  deactivateUser,
  resetUserPassword,
  getUserEmailContactData,
  deleteUser,
  resetUserEmailContactData,
};
